// extracted by mini-css-extract-plugin
module.exports = {"bioText":"about_bioText__rdNqp","familyPhoto":"about_familyPhoto__1PjV7"};